import Youtube from 'react-youtube';
import Section from '../../../components/Section';
import styles from './Video.module.scss';

function Video() {
  return (
    <Section className={styles.container}>
      <Youtube
        videoId={process.env.REACT_APP_VIDEO_ID}
        className={styles.video}
        opts={{
          playerVars: {
            autoplay: 1,
            mute: 1,
          },
        }}
        onReady={(event) => {
          event.target.pauseVideo();
          const observer = new IntersectionObserver(
            (e) => {
              if (!e?.[0].isIntersecting) return;

              event.target.playVideo();
              observer.unobserve(event.target.g);
            },
            {
              threshold: 0.5,
            },
          );
          observer.observe(event.target.g);
        }}
      />
    </Section>
  );
}

export default Video;
